/* eslint-disable @typescript-eslint/no-unused-expressions */
import React from 'react'
import { makeStyles, createStyles, Theme, Grid } from '@material-ui/core'

import PacksCard from './PacksCard'
import { Products } from '../../typings/base'
import { loadingPacksDatas } from '../Global/LoadingDatas'
import Skeleton from '@material-ui/lab/Skeleton'
import { thumbnailRatio } from '../../utils/utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(3),
    },
    skeletonCard: {
      padding: theme.spacing(0.5),
      boxShadow: theme.shadows[1],
      borderRadius: theme.shape.borderRadius,
    },
    skeletonRow: {
      marginTop: theme.spacing(2),
    },
  })
)

type Tprops = {
  //packs: Products[]
  packs: any
  text: any
  shopText: any
  settings: any
  t?: any
  latestProducts: Products[]
  packPush: []
  takeback: any
}

const PacksTab = ({
  packs,
  latestProducts,
  text,
  t,
  shopText,
  settings,
  packPush,
  takeback,
}: Tprops) => {
  const classes = useStyles()
  const packLayout = settings?.pack_layout
  const aspectRatio = thumbnailRatio(settings?.thumbnail_ratio)
  const cardWidth = settings?.medium_image_size
  const thumbWidth = settings?.small_image_size
  return (
    <section className={classes.root}>
      <Grid container spacing={8} className={'pack__grid'}>
        {packs &&
          packs.loading === true &&
          loadingPacksDatas.map((loadingPacksData) => (
            <Grid key={`item-${loadingPacksData.name}`} item xs={12} lg={6}>
              <div className={classes.skeletonCard}>
                <Skeleton variant="rect" width={'100%'} height={180} />
                <Skeleton
                  variant="rect"
                  width={'100%'}
                  height={60}
                  className={classes.skeletonRow}
                />
              </div>
            </Grid>
          ))}
        {packs &&
          packs?.items &&
          packs?.items?.map((pack, index) => {
            return (
              <PacksCard
                key={`${pack.code}-${index}`}
                latestProducts={latestProducts}
                numberPack={packs.length}
                pack={pack}
                settings={settings}
                t={t}
                text={text}
                shopText={shopText}
                index={index}
                thumbRatio={aspectRatio}
                thumbWidth={thumbWidth}
                cardWidth={cardWidth}
                packLayout={packLayout}
                packPush={packPush}
                takeback={takeback}
              />
            )
          })}
      </Grid>
    </section>
  )
}

export default PacksTab
